
/**
 * api接口统一管理
 */
import {axiosInstance} from "@/api/http";



/**
 * 统一下单
 * {
        "productId": "1543977923801829378",商品id
        "productType": 0, //商品类型  0课程
        "tradeType": 0, 支付类型：0 NATIVE 1APP 2JSAPI 3 MWEB 4 MICROPAY
    }
 * @param obj
 */
export const createOrder = data => axiosInstance.post('/payment/wechat/createOrder',data)


/**
 * 主动查询支付情况,如果已支付更新订单状态。
 * {
        "productId": "1543977923801829378",商品id
    }
 * @param obj
 */
export const payCase = courseId => axiosInstance.get('/payment/wechat/payCase/'+courseId)

/**
 *查询用户订单信息
 */
export const getCourseOrderPageList = params => axiosInstance.get('/payment-api/orderInfo/course/pageList',{params})
